<template>
    <b-modal title="Upload Brand Logo" id="uploadBrandLogoModal" hide-footer size="md">
        <b-overlay :show="busySaving">
            <div class="mb-3">
                <h6 class="mb-1">Replace the platform brand logo</h6>
                <p class="text-muted mb-0" style="font-size: 0.85rem">
                    PNG, JPG, GIF or WEBP, max 2&nbsp;MB. The new logo appears everywhere (app shell, login, order tracking).
                </p>
            </div>

            <uploader
                :options="renderUploadOptions"
                :autoStart="false"
                :ref="'attach_upload'"
                class="uploader-example"
                @change="getImage($event)"
            >
                <uploader-unsupport></uploader-unsupport>
                <uploader-drop v-if="file_src.length == 0">
                    <p>Drop logo here, or select to upload</p>
                    <uploader-btn class="btn w-50">Select Logo</uploader-btn>
                </uploader-drop>
                <div v-else class="mt-3 mb-3 border p-3 text-center">
                    <b-img :src="file_src" fluid alt="Logo preview"></b-img>
                </div>
            </uploader>

            <b-button v-if="file_src.length > 0" variant="success" class="w-100 mt-4" @click="saveLogo()">Save Logo</b-button>

            <div class="modal-footer mt-2">
                <button type="button" class="btn btn-secondary" @click="closeModal()">Cancel</button>
            </div>
        </b-overlay>
    </b-modal>
</template>

<script>
import { adminMethods } from "@/state/helpers";
//eslint-disable-next-line
import Swal from "sweetalert2";

export default {
    data: () => ({
        busySaving: false,
        file_src: "",
    }),
    computed: {
        renderUploadOptions() {
            var storage = window.localStorage;
            var AUTH_TOKEN = storage.getItem("x_token");
            var url = process.env.VUE_APP_API_BASEURL + "api/crm/uploadbrandlogo";
            var options = {
                target: url,
                headers: {
                    Authorization: "Bearer " + AUTH_TOKEN,
                },
                testChunks: false,
                withCredentials: false,
                fileParameterName: "logo",
                singleFile: true, //Limit upload to one file
            };
            return options;
        },
    },
    methods: {
        ...adminMethods,
        getImage(e) {
            const file = e.target.files[0];
            this.file_src = URL.createObjectURL(file);
        },
        saveLogo() {
            const uploaderInstance = this.$refs["attach_upload"];
            const upload = uploaderInstance.uploader;
            this.busySaving = true;
            upload.resume();
            //eslint-disable-next-line no-unused-vars
            upload.on("fileSuccess", (rootFile, file, message, chunk) => {
                var response = {};
                try {
                    response = JSON.parse(message);
                } catch (e) {
                    response = {};
                }
                upload.off("fileSuccess");
                upload.cancel();
                if (response.success) {
                    // Reload core so the freshly-signed brand_logo_src propagates everywhere.
                    this.loadCoreData()
                        .catch(() => {})
                        .finally(() => {
                            this.busySaving = false;
                            this.$swal.fire("Logo Uploaded", "The brand logo has been updated.", "success");
                            this.closeModal();
                        });
                } else {
                    this.busySaving = false;
                    this.$swal.fire("Upload failed", "The logo could not be saved. Please try again.", "error");
                }
            });
            //eslint-disable-next-line no-unused-vars
            upload.on("fileError", (rootFile, file, message, chunk) => {
                upload.off("fileError");
                upload.cancel();
                this.busySaving = false;
                var msg = "The logo could not be uploaded.";
                try {
                    var parsed = JSON.parse(message);
                    if (parsed && parsed.message) {
                        msg = parsed.message;
                    }
                } catch (e) {
                    // keep default message
                }
                this.$swal.fire("Upload failed", msg, "error");
            });
        },
        closeModal() {
            this.$bvModal.hide("uploadBrandLogoModal");
        },
    },
};
</script>
<style scoped></style>
